import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

import MediaAvatar from '../../atoms/MediaAvatar'

import { useEnvironment } from '../../../providers/EnvironmentProvider'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  rootTeams: {
    display: 'grid',
    gridTemplateColumns: '30px minmax(40px, auto)',
    alignItems: 'center'
  },

  teamsData: {
    display: 'grid',
    maxWidth: 200
  },

  menuAvatar: {
    margin: '0 10px 0 0',
    width: '20px',
    height: '20px',
    fontSize: theme.size.sm,

    '& .MuiAvatar-img': {
      background: 'rgba(173, 194, 204, 0.9)'
    }
  },

  teamLabel: {
    color: 'grey'
  },

  nameLabel: {},

  dataRow: {}
}))

const UserOption = ({ id, opt, showTeams = false }) => {
  const { user: currentUser } = useEnvironment()

  const classes = useStyles()

  const isMe = id === currentUser?.id

  // Placeholder ui for not yet loaded users
  if (!opt) {
    return (
      <div key={id} className={classes.root}>
        <div>Unknown User</div>
      </div>
    )
  }

  if (showTeams)
    return (
      <div key={id} className={classes.rootTeams}>
        <MediaAvatar user={opt} className={classes.menuAvatar} />
        <div className={classes.teamsData}>
          <label className={classes.nameLabel}>
            {opt.name}
            {isMe ? ' (me)' : ''}
          </label>
          <label className={classes.teamLabel}>
            Teams: {opt?.teams?.map(team => team.name).join(', ') || ''}
          </label>
        </div>
      </div>
    )

  return (
    <div key={id} className={classes.root}>
      <MediaAvatar user={opt} className={classes.menuAvatar} />

      <div>
        {opt.name}
        {isMe ? ' (me)' : ''}
      </div>
    </div>
  )
}

export default UserOption
